__turbopack_context__.v({
  "userAvatar": "o7Nlpa_userAvatar",
});
